import { ArrowUpRight, ShieldCheck, HeartPulse } from "lucide-react";
import { Reveal } from "../shared/Reveal";
import LangLink from "../shared/LangLink";
import { DOCTOR_REVIEW } from "../../content/doctorReviewContent";
import { AFTERCARE } from "../../content/aftercareContent";
import { getLocalizedSlug } from "../../data/localizedRoutes";
import { useI18n } from "../../i18n";

export function DoctorReviewPreview() {
  const { lang } = useI18n();
  const c = (DOCTOR_REVIEW[lang] || DOCTOR_REVIEW.en).home;
  const slug = getLocalizedSlug("doctorReview", lang);
  return (
    <section className="bg-surface py-20 md:py-28" data-testid="home-doctor-review-preview">
      <div className="container-psv grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-7">
          <span className="eyebrow mb-4 block flex items-center gap-2"><ShieldCheck className="w-4 h-4" /> {(DOCTOR_REVIEW[lang] || DOCTOR_REVIEW.en).eyebrow}</span>
          <h2 className="font-serif font-medium text-primary text-3xl md:text-5xl leading-[1.05] tracking-tight">{c.heading}</h2>
          <p className="mt-6 text-lg text-secondary-foreground font-light leading-relaxed max-w-2xl">{c.text}</p>
          <LangLink to={`/${slug}`} className="mt-8 inline-flex items-center gap-2 text-accent font-medium font-sans hover:gap-3 transition-all" data-testid="home-doctor-review-link">
            {c.cta} <ArrowUpRight className="w-4 h-4" />
          </LangLink>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <div className="rounded-[2rem] border border-border overflow-hidden grain h-[300px] md:h-[380px]">
            <img src="https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" alt="A healthcare professional reviewing patient information" className="w-full h-full object-cover" loading="lazy" width="1000" height="760" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function AftercarePreview() {
  const { lang } = useI18n();
  const c = (AFTERCARE[lang] || AFTERCARE.en).home;
  const slug = getLocalizedSlug("aftercare", lang);
  return (
    <section className="bg-background py-20 md:py-28" data-testid="home-aftercare-preview">
      <div className="container-psv grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <Reveal delay={0.1} className="lg:col-span-5 order-2 lg:order-1">
          <div className="rounded-[2rem] border border-border overflow-hidden grain h-[300px] md:h-[380px]">
            <img src="https://images.unsplash.com/photo-1584515933487-779824d29309?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" alt="Calm recovery environment for an international patient" className="w-full h-full object-cover" loading="lazy" width="1000" height="760" />
          </div>
        </Reveal>
        <Reveal className="lg:col-span-7 order-1 lg:order-2">
          <span className="eyebrow mb-4 block flex items-center gap-2"><HeartPulse className="w-4 h-4" /> {(AFTERCARE[lang] || AFTERCARE.en).eyebrow}</span>
          <h2 className="font-serif font-medium text-primary text-3xl md:text-5xl leading-[1.05] tracking-tight">{c.heading}</h2>
          <p className="mt-6 text-lg text-secondary-foreground font-light leading-relaxed max-w-2xl">{c.text}</p>
          <LangLink to={`/${slug}`} className="mt-8 inline-flex items-center gap-2 text-accent font-medium font-sans hover:gap-3 transition-all" data-testid="home-aftercare-link">
            {c.cta} <ArrowUpRight className="w-4 h-4" />
          </LangLink>
        </Reveal>
      </div>
    </section>
  );
}
